<template>
    <ion-buttons>
      <router-link class="btn-icon btn-vertical" v-for="menu in menus" :key="menu.text" :to="menu.link">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
              <p>{{menu.text}}</p>
        </router-link>
    </ion-buttons>
</template>


<script>
import { mapGetters } from 'vuex'


export default {
  name: "MenuMain",
  data(){
    return {
      menus:[]
    }
  },
  computed: {
    ...mapGetters([
      'getMenu',
    ])
  },
  created (){
    this.menus = this.getMenu;
  }
}
</script>